export const apiUrlEnvUtils = (apiUrl) => {
    return typeof window !== 'undefined' ? window?.variables_env[apiUrl] : process.env[apiUrl]
}
